module.exports = __webpack_public_path__ + "static/logo-29b3c55bb23fc1612a7ff470e527f43a.png";